import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const scrollToPricing = () => {
    window.location.href = '/pricing';
  };
  return <section className="relative bg-white dark:bg-[#0C1B26] overflow-hidden" data-id="element-271">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[700px]" data-id="element-272">
        {/* Left Column - Hero Image (Desktop) / Second on Mobile */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative order-2 lg:order-1 min-h-[400px] lg:min-h-full" data-id="element-273">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5nAynpZr92nWzvxTTnn6Kd/image.png" alt="Web designer sketching website wireframes and planning homepage layout - Bright Pixxel Studios professional web design process" className="absolute inset-0 w-full h-full object-cover" loading="eager" fetchPriority="high" data-id="element-274" />
        </motion.div>

        {/* Right Column - Text Content (Desktop) / First on Mobile */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="bg-[#212C34] px-6 sm:px-8 lg:px-12 xl:px-16 py-12 lg:py-16 flex flex-col justify-center order-1 lg:order-2" data-id="element-275">
          {/* Top Badge */}
          <div className="inline-flex items-center gap-2 bg-[#0DC3DC]/20 px-4 py-2 rounded-full mb-6 w-fit" data-id="element-276">
            <span className="w-2 h-2 bg-[#0DC3DC] rounded-full animate-pulse" data-id="element-277"></span>
            <span className="text-sm font-medium text-[#0DC3DC]" data-id="element-278">
              Professional Web Design Studio
            </span>
          </div>

          <h1 className="font-bold mb-6 leading-tight text-white text-[clamp(2rem,5vw,3.5rem)]" data-id="element-279">
            Affordable, Beautiful Websites That Convert
          </h1>

          <p className="text-white/90 mb-8 leading-relaxed text-[clamp(1rem,1.5vw,1.25rem)]" data-id="element-280">
            UK-based web design, e-commerce and SEO built for performance and
            results.
          </p>

          {/* Key Benefits */}
          <div className="space-y-3 mb-8" data-id="element-281">
            <div className="flex items-center gap-3" data-id="element-282">
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#0DC3DC]/20 flex items-center justify-center" data-id="element-283">
                <svg className="w-3 h-3 text-[#0DC3DC]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-284">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-285" />
                </svg>
              </div>
              <span className="text-white/80 text-base" data-id="element-286">
                Fast turnaround: 7-14 days
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-287">
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#0DC3DC]/20 flex items-center justify-center" data-id="element-288">
                <svg className="w-3 h-3 text-[#0DC3DC]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-289">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-290" />
                </svg>
              </div>
              <span className="text-white/80 text-base" data-id="element-291">
                100% ownership - no lock-ins
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-292">
              <div className="flex-shrink-0 w-5 h-5 rounded-full bg-[#0DC3DC]/20 flex items-center justify-center" data-id="element-293">
                <svg className="w-3 h-3 text-[#0DC3DC]" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-294">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-295" />
                </svg>
              </div>
              <span className="text-white/80 text-base" data-id="element-296">
                Free 3-month hosting included
              </span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-297">
            <button onClick={scrollToContact} className="w-full sm:w-auto px-8 py-4 bg-[#0DC3DC] text-[#0C1B26] font-bold rounded-full shadow-lg hover:bg-[#0DC3DC]/90 transition-all duration-300 hover:scale-105 min-h-[44px] text-base md:text-lg" aria-label="Get a free quote for your website" data-id="element-298">
              Get a Free Quote
            </button>
            <button onClick={scrollToPricing} className="w-full sm:w-auto px-8 py-4 bg-white text-[#212C34] font-bold rounded-full shadow-lg border border-[#0DC3DC]/40 hover:bg-[#0DC3DC] hover:text-white transition-all duration-300 hover:scale-105 min-h-[44px] text-base md:text-lg" aria-label="View our pricing packages" data-id="element-299">
              View Pricing
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="pt-6 border-t border-white/10" data-id="element-300">
            <p className="text-white/60 text-xs mb-3" data-id="element-301">
              Trusted by UK businesses
            </p>
            <div className="flex items-center gap-6 text-white/70 text-sm" data-id="element-302">
              <div className="flex items-center gap-2" data-id="element-303">
                <span className="text-[#0DC3DC] font-bold text-lg" data-id="element-304">50+</span>
                <span className="text-xs" data-id="element-305">
                  Projects
                  <br data-id="element-306" />
                  Delivered
                </span>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-307"></div>
              <div className="flex items-center gap-2" data-id="element-308">
                <span className="text-[#0DC3DC] font-bold text-lg" data-id="element-309">5★</span>
                <span className="text-xs" data-id="element-310">
                  Client
                  <br data-id="element-311" />
                  Rating
                </span>
              </div>
              <div className="w-px h-8 bg-white/10" data-id="element-312"></div>
              <div className="flex items-center gap-2" data-id="element-313">
                <span className="text-[#0DC3DC] font-bold text-lg" data-id="element-314">24h</span>
                <span className="text-xs" data-id="element-315">
                  Response
                  <br data-id="element-316" />
                  Time
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}